import ToolAlignment from './ToolAlignment';
import { type Alignment } from '../../../types/aha-editor';

class ToolAlignLeft extends ToolAlignment {
  static toolName = 'Left align';
  static iconClass = 'fa-regular fa-align-left';
  static alignment: Alignment = 'left';
}

export default ToolAlignLeft;
